(function () {
'use strict';
var VERSION = '2026-10-04.smooth1.ad1';
var ROOT = '[data-ld-collection]';
var KEY = 'ld-product-view';
var prior = window.LDCollectionFeed;
if (prior && prior.version === VERSION) { prior.boot(document); return; }
if (prior && prior.destroy) prior.destroy();
var instances = new Map();
var globalOff = [];
function listen(target, event, fn, options, bag) {
if (!target) return;
target.addEventListener(event, fn, options);
bag.push(function () { target.removeEventListener(event, fn, options); });
}
function number(value, fallback) {
var result = Number(value);
return Number.isFinite(result) && result >= 0 ? Math.floor(result) : fallback;
}
function text(el, value) {
if (!el) return;
value = String(value);
if (el.textContent === value) return;
if (el.childNodes.length === 1 && el.firstChild.nodeType === 3) el.firstChild.nodeValue = value;
else el.textContent = value;
}
function storageGet(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } }
function storageSet(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
function defaultView(root) { return root.dataset.ldDefaultView === 'second' ? 'second' : 'first'; }
function viewKey(root) { return KEY + ':v2:' + defaultView(root); }
function getView(root) {
var fallback = defaultView(root);
if (window.Shopify && window.Shopify.designMode) return fallback;
var saved = storageGet(viewKey(root));
return saved === 'first' || saved === 'second' ? saved : fallback;
}
function plainClick(e) { return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey; }
function all(scope, selector) { return Array.from(scope.querySelectorAll(selector)); }
function directCards(grid) {
if (!grid) return [];
return Array.from(grid.children).filter(function (el) { return el.hasAttribute('data-ld-product-id'); });
}
function visibleCards(cards) {
return cards.filter(function (card) { return !card.hasAttribute('data-ld-ad-duplicate'); });
}
function metaFrom(root) {
var node = root && root.querySelector('[data-ld-feed-meta]');
if (!node) throw new Error('Brak danych listy w odpowiedzi sklepu.');
var m = JSON.parse(node.textContent);
['page', 'offset', 'total', 'pageSize', 'pages'].forEach(function (key) {
if (!Number.isSafeInteger(m[key]) || m[key] < 0) throw new Error('Nieprawidłowe dane listy: ' + key);
});
if (m.version !== 1 || !m.section || !m.collection || !m.pageParam || m.page < 1 || m.pageSize < 1) {
throw new Error('Niezgodna wersja danych listy.');
}
return m;
}
function signature(m) {
var filters = (m.filters || []).map(function (pair) { return JSON.stringify(pair); }).sort();
return JSON.stringify([m.collection, m.path, m.sort, m.currency, filters]);
}
function hash(value) {
var h = 2166136261;
for (var i = 0; i < value.length; i++) { h ^= value.charCodeAt(i); h = Math.imul(h, 16777619); }
return (h >>> 0).toString(36);
}
function scrollParent(el) {
for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
var style = getComputedStyle(p);
if (/(auto|scroll)/.test(style.overflowY) && p.scrollHeight > p.clientHeight + 2) return p;
}
return null;
}
function Controller(root) {
this.root = root;
this.id = root.dataset.ldSection;
this.meta = metaFrom(root);
this.initialPage = this.meta.page;
this.baseOffset = this.meta.offset;
this.sig = signature(this.meta);
this.grid = root.querySelector('[data-ld-product-grid]');
this.bar = root.querySelector('[data-ld-facets-root]');
this.panel = root.querySelector('[data-ld-facets-panel]');
this.toggle = root.querySelector('[data-ld-facets-toggle]');
this.tools = root.querySelector('[data-ld-feed-tools]');
this.status = root.querySelector('[data-ld-feed-status]');
this.title = root.querySelector('[data-ld-feed-title]');
this.hint = root.querySelector('[data-ld-feed-hint]');
this.skeleton = root.querySelector('[data-ld-feed-skeleton]');
var copyNode = root.querySelector('[data-ld-feed-copy]');
this.copy = copyNode ? JSON.parse(copyNode.textContent) : {};
this.buffer = null;
this.scrollSpeed = 0;
this.scrollSampleAt = performance.now();
this.fetchTime = 800;
this.loadButton = root.querySelector('[data-ld-load-more]');
this.autoButton = root.querySelector('[data-ld-auto-toggle]');
this.fallback = root.querySelector('[data-ld-feed-fallback]');
this.pagination = root.querySelector('[data-ld-pagination]');
this.cards = directCards(this.grid);
this.ids = new Set(this.cards.map(function (c) { return c.dataset.ldProductId; }));
this.off = [];
this.frame = 0;
this.autoArmed = true;
this.autoTravel = 0;
this.inputSerial = 0;
this.gateSerial = 0;
this.lastIntentAt = -Infinity;
this.lastIntentDown = false;
this.correctingScroll = false;
this.pending = false;
this.destroyed = false;
this.paused = false;
this.navigating = false;
this.failed = false;
this.stale = false;
this.ended = !this.meta.next;
this.auto = root.dataset.ldInfinite !== 'false';
this.prefetch = number(root.dataset.ldPrefetch, 700);
this.timeoutMs = number(root.dataset.ldTimeout, 15000);
this.currentView = getView(root);
this.scrollRoot = scrollParent(root);
this.lastPageScroll = this.scrollPosition();
this.initialScroll = this.lastPageScroll;
this.abort = null;
this.observer = null;
this.resizeObserver = null;
this.restoreTarget = null;
this.restoring = false;
this.visited = new Set([this.meta.page]);
this.startUrl = new URL(window.location.href);
this.startUrl.hash = '';
this.startUrl.searchParams.delete('section_id');
this.startUrl.searchParams.delete('sections');
this.startUrl.searchParams.delete('sections[]');
this.resumeKey = 'ld-feed-resume:' + hash(this.startUrl.pathname + '|' + this.sig + '|' + this.id);
this.nf = new Intl.NumberFormat(document.documentElement.lang || 'pl-PL');
this.readPosition = this.baseOffset;
this.nextUrl = this.meta.next ? this.resolvePage(this.meta.next, this.meta.page + 1) : null;
this.validateCards(this.cards, this.meta, false);
this.bind();
this.prepare(root, false);
this.closeFilters(false);
this.setView(this.currentView, false);
this.enableFeed();
this.setupObservers();
this.tryRestore();
this.warmNext();
this.requestFrame();
}
Controller.prototype.resolvePage = function (raw, expectedPage) {
var result = new URL(raw, this.startUrl.href);
if (result.origin !== this.startUrl.origin || result.pathname.replace(/\/$/, '') !== this.startUrl.pathname.replace(/\/$/, '')) {
throw new Error('Następna strona prowadzi poza bieżącą kolekcję.');
}
var actualPage = number(result.searchParams.get(this.meta.pageParam), 0);
if (actualPage !== expectedPage) throw new Error('Nieprawidłowy numer następnej strony.');
var url = new URL(this.startUrl.href);
url.searchParams.set(this.meta.pageParam, String(expectedPage));
var shopify = window.Shopify;
if (shopify && shopify.designMode && shopify.theme && shopify.theme.id) {
url.searchParams.set('preview_theme_id', String(shopify.theme.id));
}
url.hash = '';
return url;
};
Controller.prototype.validateCards = function (cards, m, incoming) {
var pageSlots = Math.min(m.pageSize, Math.max(0, m.total - m.offset));
var expected = m.rendered === undefined ? pageSlots : m.rendered;
if (!Number.isSafeInteger(expected) || expected < 0 || expected > pageSlots || cards.length !== expected) {
throw new Error('Odpowiedź sklepu zawiera niepełną stronę produktów.');
}
var unique = new Set();
var previousIndex = m.offset;
for (var i = 0; i < cards.length; i++) {
var id = cards[i].dataset.ldProductId;
var index = number(cards[i].dataset.ldProductIndex, -1);
if (!id || unique.has(id) || index <= previousIndex || index > m.offset + pageSlots) throw new Error('Niespójna kolejność produktów.');
previousIndex = index;
if (incoming && this.ids.has(id)) {
var duplicate = new Error('Kolejność produktów zmieniła się w sklepie.'); duplicate.stale = true; throw duplicate;
}
unique.add(id);
}
};
Controller.prototype.viewport = function () {
var vv = window.visualViewport;
var top = vv ? vv.offsetTop : 0;
var bottom = top + (vv ? vv.height : window.innerHeight);
if (this.scrollRoot) {
var r = this.scrollRoot.getBoundingClientRect();
top = Math.max(top, r.top); bottom = Math.min(bottom, r.bottom);
}
return { top: top, bottom: bottom, height: Math.max(1, bottom - top) };
};
Controller.prototype.headerBottom = function (vp) {
var nav = document.querySelector('.desk-nav-sec');
var header = nav ? nav.closest('[id^="shopify-section-"]') : document.querySelector('sticky-header');
if (!header) return vp.top;
var r = header.getBoundingClientRect();
return r.height > 0 && r.bottom > vp.top && r.top < vp.bottom ? Math.max(vp.top, r.bottom) : vp.top;
};
Controller.prototype.bottomLimit = function (vp) {
var bottom = vp.bottom;
all(document, '[id^="LDProgress-"]').forEach(function (bar) {
var r = bar.getBoundingClientRect();
if (r.height > 0 && r.width > 0 && r.top > vp.top && r.top < bottom && r.bottom >= vp.bottom - 100) bottom = r.top - 8;
});
return bottom;
};
Controller.prototype.requestFrame = function () {
if (this.frame || this.destroyed) return;
var self = this;
this.frame = requestAnimationFrame(function () {
self.frame = 0;
if (self.destroyed || !self.root.isConnected) return;
self.updateGeometry();
self.checkLoad();
});
};
Controller.prototype.updateGeometry = function () {
var vp = this.viewport();
var mobile = matchMedia('(max-width: 989px)').matches;
if (this.bar && mobile) {
var headerBottom = this.headerBottom(vp);
var stickyTop = Math.max(0, headerBottom - (this.scrollRoot ? vp.top : 0));
this.bar.style.setProperty('--ld-mobile-filter-top', stickyTop + 'px');
var barRect = this.bar.getBoundingClientRect();
this.bar.classList.toggle('is-ld-stuck', barRect.top <= headerBottom + 1 && (window.scrollY > 10 || (this.scrollRoot && this.scrollRoot.scrollTop > 10)));
var room = Math.max(100, Math.min(vp.height * 0.62, this.bottomLimit(vp) - barRect.bottom - 12));
this.bar.style.setProperty('--ld-panel-max', Math.floor(room) + 'px');
this.bar.style.removeProperty('--ld-desktop-filter-top');
} else if (this.bar) {
this.bar.style.removeProperty('--ld-mobile-filter-top');
this.bar.classList.remove('is-ld-stuck');
var desktopTop = Math.max(0, this.headerBottom(vp) - (this.scrollRoot ? vp.top : 0)) + 12;
this.bar.style.setProperty('--ld-desktop-filter-top', Math.round(desktopTop) + 'px');
}
var cards = visibleCards(this.cards);
if (!cards.length || this.isFiltersOpen() || this.restoring) { this.updateMeter(); return; }
var bottom = this.bottomLimit(vp);
var lo = 0, hi = cards.length - 1, last = -1;
while (lo <= hi) {
var mid = Math.floor((lo + hi) / 2);
var r = cards[mid].getBoundingClientRect();
if (r.top + Math.min(72, r.height * 0.22) <= bottom) { last = mid; lo = mid + 1; }
else hi = mid - 1;
}
this.readPosition = last >= 0 ? number(cards[last].dataset.ldProductIndex, this.baseOffset) : this.baseOffset;
this.updateMeter();
};
Controller.prototype.updateMeter = function () {
var total = this.meta.total;
var position = Math.min(total, Math.max(0, this.readPosition));
var detail = {
position: position,
total: total,
remaining: Math.max(0, total - position),
loaded: this.cards.length,
sectionId: this.id,
signature: this.sig
};
window.__LD_CATALOG_PROGRESS__ = detail;
try {
document.dispatchEvent(new CustomEvent('ld:catalog-progress', { detail: detail }));
} catch (error) {}
};
Controller.prototype.isFiltersOpen = function () {
return !!(this.toggle && this.toggle.getAttribute('aria-expanded') === 'true' && matchMedia('(max-width: 989px)').matches);
};
Controller.prototype.closeFilters = function (focus) {
if (!this.toggle || !this.panel) return;
this.toggle.setAttribute('aria-expanded', 'false');
this.toggle.setAttribute('aria-label', 'Otwórz filtry i sortowanie');
this.panel.hidden = true;
this.panel.scrollTop = 0;
if (focus) this.toggle.focus({ preventScroll: true });
this.requestFrame();
};
Controller.prototype.openFilters = function () {
this.closeDiscovery();
if (!this.toggle || !this.panel) return;
this.toggle.setAttribute('aria-expanded', 'true');
this.toggle.setAttribute('aria-label', 'Zamknij filtry i sortowanie');
this.panel.hidden = false;
this.panel.scrollTop = 0;
this.requestFrame();
};
Controller.prototype.setImage = function (img, view, animate) {
if (!(img instanceof HTMLImageElement)) return;
var first = img.getAttribute('data-image-1');
var second = img.getAttribute('data-image-2');
var showSecond = view === 'second' && !!second;
var desired = showSecond ? second : first;
if (!desired) return;
if (!img.hasAttribute('data-ld-first-srcset')) img.setAttribute('data-ld-first-srcset', img.getAttribute('srcset') || '');
if (showSecond) img.removeAttribute('srcset');
else if (img.getAttribute('data-ld-first-srcset')) img.setAttribute('srcset', img.getAttribute('data-ld-first-srcset'));
var changed = img.getAttribute('src') !== desired;
img.setAttribute('src', desired);
img.alt = img.getAttribute(showSecond ? 'data-alt-2' : 'data-alt-1') || '';
img.setAttribute('data-showing-second', showSecond ? 'true' : 'false');
img.style.removeProperty('opacity'); img.style.removeProperty('transform');
var wrap = img.closest('.best-img');
var eye = wrap && wrap.querySelector('.product-eye-toggle');
if (eye) {
eye.classList.toggle('is-active', showSecond);
eye.setAttribute('aria-pressed', showSecond ? 'true' : 'false');
var label = showSecond ? 'Pokaż wzór tego tatuażu' : 'Pokaż ten tatuaż na skórze';
eye.setAttribute('aria-label', label); eye.setAttribute('title', label);
}
if (changed && animate && img.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
var r = img.getBoundingClientRect();
if (r.bottom >= 0 && r.top <= window.innerHeight) img.animate([{ opacity: 0.45 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
}
};
Controller.prototype.setView = function (view, animate) {
var self = this;
this.currentView = view === 'second' ? 'second' : 'first';
all(this.root, '[data-ld-mobile-view], [data-ld-desktop-view]').forEach(function (button) {
var selected = (button.dataset.ldMobileView || button.dataset.ldDesktopView) === self.currentView;
button.classList.toggle('is-active', selected);
button.setAttribute('aria-pressed', selected ? 'true' : 'false');
});
all(this.root, '.ld-mobile-view-switch, .ld-desktop-view-switch__pill').forEach(function (pill) { pill.classList.toggle('is-second', self.currentView === 'second'); });
all(this.root, 'img.product-card-main-image').forEach(function (img) { self.setImage(img, self.currentView, animate); });
};
Controller.prototype.prepare = function (scope, incoming) {
var self = this;
var animations = all(scope, '.scroll-trigger, .animate--slide-in, .scroll-trigger--offscreen');
if (scope.matches && scope.matches('.scroll-trigger, .animate--slide-in, .scroll-trigger--offscreen')) animations.unshift(scope);
animations.forEach(function (el) {
el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
el.style.removeProperty('--animation-order');
});
all(scope, 'img.product-card-main-image').forEach(function (img) { self.setImage(img, self.currentView, false); });
all(scope, '[data-ld-bundle-track]').forEach(function (track) { self.setupTrack(track); });
if (incoming) {
all(scope, 'script:not([type="application/json"])').forEach(function (script) { script.remove(); });
}
};
Controller.prototype.setupTrack = function (track) {
if (track.dataset.ldFeedTrackReady === VERSION) return;
track.dataset.ldFeedTrackReady = VERSION;
var start = null;
var moved = false;
var preventUntil = 0;
var off = this.off;
listen(track, 'pointerdown', function (e) {
if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button, input, select')) return;
start = { id: e.pointerId, x: e.clientX, left: track.scrollLeft }; moved = false;
}, false, off);
listen(track, 'pointermove', function (e) {
if (!start || start.id !== e.pointerId) return;
var delta = e.clientX - start.x;
if (!moved && Math.abs(delta) < 7) return;
moved = true; track.classList.add('is-dragging');
if (!track.hasPointerCapture(e.pointerId)) track.setPointerCapture(e.pointerId);
e.preventDefault(); track.scrollLeft = start.left - delta;
}, { passive: false }, off);
function end(e) {
if (!start || e.pointerId !== start.id) return;
if (moved) preventUntil = Date.now() + 100;
start = null; track.classList.remove('is-dragging');
}
listen(track, 'pointerup', end, false, off);
listen(track, 'pointercancel', end, false, off);
listen(track, 'lostpointercapture', end, false, off);
listen(track, 'click', function (e) {
if (Date.now() < preventUntil) { e.preventDefault(); e.stopPropagation(); }
}, true, off);
};
Controller.prototype.closeDiscovery = function (except) {
all(this.root, '[data-ld-discovery-group][open]').forEach(function (group) {
if (group !== except) group.open = false;
});
};
Controller.prototype.showGuideStep = function (key) {
var stages = all(this.root, '[data-ld-guide-stage]');
if (!stages.some(function (stage) { return stage.dataset.ldGuideStage === key; })) return;
this.closeDiscovery();
stages.forEach(function (stage) { stage.hidden = stage.dataset.ldGuideStage !== key; });
var selected = stages.find(function (stage) { return stage.dataset.ldGuideStage === key; });
var title = selected && selected.querySelector('[data-ld-stage-title]');
if (title) title.focus({ preventScroll: true });
};
Controller.prototype.filterURL = function (link) {
var url = new URL(link.href, this.startUrl.href);
var param = link.dataset.ldFilterParam;
var value = link.dataset.ldFilterValue;
if (param && param.indexOf('filter.') === 0 && value !== undefined) {
var values = this.startUrl.searchParams.getAll(param);
values = values.filter(function (entry) { return entry !== value && entry !== ''; });
if (link.dataset.ldFilterActive !== 'true') values.push(value);
url.searchParams.delete(param);
Array.from(new Set(values)).forEach(function (entry) { url.searchParams.append(param, entry); });
}
if (link.hasAttribute('data-ld-filter-clear')) {
Array.from(url.searchParams.keys()).forEach(function (key) { if (key.indexOf('filter.') === 0) url.searchParams.delete(key); });
}
url.searchParams.delete(this.meta.pageParam);
if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', this.startUrl.searchParams.get('sort_by') || this.meta.sort);
var start = this.startUrl;
['preview_theme_id', 'view', 'q', 'type', 'options[prefix]', 'options[unavailable_products]'].forEach(function (key) {
if (!url.searchParams.has(key) && start.searchParams.has(key)) url.searchParams.set(key, start.searchParams.get(key));
});
url.searchParams.set('filter.v.availability', '1');
return url;
};
Controller.prototype.bind = function () {
var self = this;
listen(this.root, 'click', function (e) {
var target = e.target instanceof Element ? e.target : e.target.parentElement;
if (!target) return;
if (target.closest('[data-ld-facets-toggle]')) {
e.preventDefault(); self.isFiltersOpen() ? self.closeFilters(false) : self.openFilters(); return;
}
var guideStep = target.closest('[data-ld-guide-step]');
if (guideStep) { e.preventDefault(); self.showGuideStep(guideStep.dataset.ldGuideStep); return; }
if (target.closest('[data-ld-close-filters]')) { e.preventDefault(); self.closeFilters(true); return; }
var viewButton = target.closest('[data-ld-mobile-view], [data-ld-desktop-view]');
if (viewButton) {
e.preventDefault(); var view = viewButton.dataset.ldMobileView || viewButton.dataset.ldDesktopView;
storageSet(viewKey(self.root), view); self.setView(view, true); return;
}
var eye = target.closest('.product-eye-toggle');
if (eye) {
e.preventDefault(); e.stopPropagation();
var image = eye.closest('.best-img').querySelector('img.product-card-main-image');
if (image) self.setImage(image, image.dataset.showingSecond === 'true' ? 'first' : 'second', true);
return;
}
var arrow = target.closest('[data-ld-bundle-direction]');
if (arrow) {
e.preventDefault(); e.stopPropagation();
var track = arrow.closest('[data-ld-bundle-carousel]').querySelector('[data-ld-bundle-track]');
if (track) track.scrollBy({ left: (arrow.dataset.ldBundleDirection === 'prev' ? -1 : 1) * Math.max(180, track.clientWidth * 0.82), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
return;
}
if (target.closest('[data-ld-load-more]')) { e.preventDefault(); self.failed = false; self.load(true); return; }
if (target.closest('[data-ld-auto-toggle]')) {
e.preventDefault(); self.auto = !self.auto;
if (self.auto) { self.autoArmed = true; self.autoTravel = 0; }
self.renderState(); self.warmNext(); self.requestFrame(); return;
}
var filterLink = target.closest('.ld-visible-facets__chip, .ld-visible-facets__clear, .ld-active-filter-pill, .ld-active-filters-mobile__clear, [data-ld-guide-link]');
if (filterLink && plainClick(e)) {
e.preventDefault(); e.stopPropagation();
var url = self.filterURL(filterLink);
self.closeDiscovery(); self.closeFilters(false); self.cancelForNavigation();
window.location.assign(url.href); return;
}
var productLink = target.closest('a[href]');
if (productLink && self.grid && self.grid.contains(productLink) && plainClick(e)) self.savePosition();
}, false, this.off);
listen(this.root, 'toggle', function (e) {
if (e.target.matches('[data-ld-discovery-group]') && e.target.open) {
self.closeDiscovery(e.target); self.closeFilters(false);
}
}, true, this.off);
listen(this.root, 'input', function (e) {
if (!e.target.matches('[data-ld-option-search]')) return;
var group = e.target.closest('.ld-filter-options');
function normalize(value) { return value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l'); }
var query = normalize(e.target.value.trim());
var visible = 0;
all(group, '[data-ld-option-label]').forEach(function (option) {
option.hidden = normalize(option.dataset.ldOptionLabel).indexOf(query) === -1;
if (!option.hidden) visible++;
});
var empty = group.querySelector('[data-ld-search-empty]');
if (empty) empty.hidden = visible > 0;
}, false, this.off);
listen(this.root, 'keydown', function (e) {
if (e.key === ' ' && e.target.matches('a[data-ld-guide-link][role="button"]')) { e.preventDefault(); e.target.click(); }
}, false, this.off);
listen(this.root, 'change', function (e) {
if (!e.target.matches('[data-ld-sort]')) return;
var url = new URL(self.startUrl.href);
url.searchParams.set('sort_by', e.target.value); url.searchParams.delete(self.meta.pageParam);
self.closeFilters(false); self.cancelForNavigation(); window.location.assign(url.href);
}, false, this.off);
listen(document, 'keydown', function (e) {
if (e.key !== 'Escape') return;
var openGroup = self.root.querySelector('[data-ld-discovery-group][open]');
if (openGroup) { self.closeDiscovery(); openGroup.querySelector('summary').focus(); }
if (self.isFiltersOpen()) self.closeFilters(true);
}, false, this.off);
listen(document, 'click', function (e) {
if (self.bar && self.isFiltersOpen() && !self.bar.contains(e.target)) self.closeFilters(false);
if (!e.target.closest('[data-ld-discovery]')) self.closeDiscovery();
}, false, this.off);
listen(document, 'scroll', function (e) {
if ((!self.scrollRoot && e.target === document) || e.target === self.scrollRoot) self.onPageScroll();
self.requestFrame();
}, { capture: true, passive: true }, this.off);
listen(window, 'wheel', function (e) {
if (!e.ctrlKey && Math.abs(e.deltaY) > Math.abs(e.deltaX)) self.noteScrollIntent(e.deltaY > 0);
}, { passive: true }, this.off);
var touchY = null;
listen(window, 'touchstart', function (e) { touchY = e.touches.length === 1 ? e.touches[0].clientY : null; }, { passive: true }, this.off);
listen(window, 'touchmove', function (e) {
if (touchY === null || e.touches.length !== 1) return;
var y = e.touches[0].clientY;
if (Math.abs(y - touchY) > 2) self.noteScrollIntent(y < touchY);
touchY = y;
}, { passive: true }, this.off);
listen(window, 'touchend', function () { touchY = null; }, { passive: true }, this.off);
listen(window, 'keydown', function (e) {
if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || e.target.closest('input, textarea, select, button, [contenteditable="true"]')) return;
if (['ArrowDown', 'PageDown', 'End'].indexOf(e.key) >= 0 || (e.key === ' ' && !e.shiftKey)) self.noteScrollIntent(true);
else if (['ArrowUp', 'PageUp', 'Home'].indexOf(e.key) >= 0 || (e.key === ' ' && e.shiftKey)) self.noteScrollIntent(false);
}, false, this.off);
var draggingScrollbar = false;
listen(window, 'pointerdown', function (e) {
if (e.button !== 0 || e.pointerType !== 'mouse') return;
var r = self.scrollRoot && self.scrollRoot.getBoundingClientRect();
draggingScrollbar = r ? (e.target === self.scrollRoot && e.clientX >= r.right - 18) : e.clientX >= document.documentElement.clientWidth - 18;
if (draggingScrollbar) self.noteScrollIntent(true);
}, { passive: true }, this.off);
listen(window, 'pointermove', function () { if (draggingScrollbar) self.noteScrollIntent(true); }, { passive: true }, this.off);
listen(window, 'pointerup', function () { draggingScrollbar = false; }, { passive: true }, this.off);
listen(window, 'resize', function () { self.requestFrame(); }, { passive: true }, this.off);
if (window.visualViewport) {
listen(window.visualViewport, 'resize', function () { self.requestFrame(); }, { passive: true }, this.off);
listen(window.visualViewport, 'scroll', function () { self.requestFrame(); }, { passive: true }, this.off);
}
listen(window, 'pagehide', function () {
self.savePosition(); self.paused = true;
if (self.abort) self.abort.abort();
}, false, this.off);
listen(window, 'pageshow', function (e) {
self.paused = false; self.navigating = false; self.closeFilters(false); self.closeDiscovery();
if (e.persisted) { self.failed = false; self.buffer = null; self.renderState(); }
self.warmNext(); self.requestFrame();
}, false, this.off);
listen(window, 'online', function () { if (!self.stale) { self.failed = false; self.buffer = null; self.warmNext(); self.renderState(); self.requestFrame(); } }, false, this.off);
listen(document, 'visibilitychange', function () { if (!document.hidden) { self.warmNext(); self.requestFrame(); } }, false, this.off);
['wheel', 'touchstart'].forEach(function (event) {
listen(window, event, function () { if (self.restoring) { self.restoring = false; self.restoreTarget = null; self.renderState(); } }, { passive: true }, self.off);
});
};
Controller.prototype.cancelForNavigation = function () {
this.navigating = true; this.restoring = false;
if (this.abort) this.abort.abort();
};
Controller.prototype.enableFeed = function () {
if (!this.grid || !this.tools || this.root.dataset.ldFeedEnabled === 'false' || !window.fetch || !window.AbortController) return;
this.enabled = true;
this.root.dataset.ldController = VERSION;
this.tools.hidden = false;
if (this.pagination && this.meta.page === 1) this.pagination.hidden = true;
this.renderState();
};
Controller.prototype.setupObservers = function () {
var self = this;
if (this.enabled && this.tools && window.IntersectionObserver) {
this.observer = new IntersectionObserver(function (entries) {
if (entries.some(function (entry) { return entry.isIntersecting; })) self.requestFrame();
}, { root: this.scrollRoot, rootMargin: '6000px 0px', threshold: 0 });
this.observer.observe(this.tools);
}
if (window.ResizeObserver) {
this.resizeObserver = new ResizeObserver(function () { self.requestFrame(); });
if (this.grid) this.resizeObserver.observe(this.grid);
if (this.bar) this.resizeObserver.observe(this.bar);
}
};
Controller.prototype.scrollPosition = function () {
return this.scrollRoot ? this.scrollRoot.scrollTop : window.scrollY;
};
Controller.prototype.noteScrollIntent = function (down) {
this.inputSerial++;
this.lastIntentAt = performance.now();
this.lastIntentDown = down;
if (!down) this.autoTravel = 0;
};
Controller.prototype.resetLoadGate = function () {
this.autoArmed = true;
this.autoTravel = 0;
};
Controller.prototype.onPageScroll = function () {
var position = this.scrollPosition();
var delta = position - this.lastPageScroll;
var now = performance.now();
var elapsed = Math.max(16, now - this.scrollSampleAt);
this.scrollSampleAt = now;
this.lastPageScroll = position;
if (!this.correctingScroll && !this.restoring) this.scrollSpeed = delta > 0 ? Math.min(8, delta / elapsed) : 0;
};
Controller.prototype.loadDistance = function () {
var vp = this.viewport();
var speed = performance.now() - this.scrollSampleAt < 1200 ? this.scrollSpeed : 0;
return Math.min(8000, Math.max(this.prefetch, vp.height * 5, 2400, speed * (this.fetchTime + 500)));
};
Controller.prototype.checkLoad = function () {
if (!this.enabled || !this.auto || this.pending || this.correctingScroll || this.ended || this.failed || this.stale || this.paused || this.navigating || this.restoring || document.hidden || this.isFiltersOpen()) return;
if (!this.root.getClientRects().length) return;
var vp = this.viewport();
if (this.tools.getBoundingClientRect().top <= this.bottomLimit(vp) + this.loadDistance()) this.load(false);
};
Controller.prototype.fetchPage = async function (pageURL, expectedPage) {
var started = performance.now();
var sectionURL = new URL(pageURL.href);
sectionURL.searchParams.set('section_id', this.id);
var result;
try {
result = this.readResponse(await this.fetchHTML(sectionURL), expectedPage);
} catch (error) {
if (error.stale || this.paused || this.navigating || this.destroyed || error.name === 'AbortError') throw error;
result = this.readResponse(await this.fetchHTML(pageURL), expectedPage);
}
this.fetchTime = Math.min(5000, Math.max(300, performance.now() - started));
return result;
};
Controller.prototype.warmImages = function (result) {
if (!result || !result.cards) return;
var self = this;
var urls = new Set();
result.cards.slice(0, 12).forEach(function (card) {
var img = card.querySelector('img.product-card-main-image');
if (!img) return;
self.setImage(img, self.currentView, false);
var preloaded = new Image();
preloaded.decoding = 'async';
if (img.getAttribute('sizes')) preloaded.sizes = img.getAttribute('sizes');
if (img.getAttribute('srcset')) preloaded.srcset = img.getAttribute('srcset');
var src = img.getAttribute('src');
if (src && !urls.has(src)) { urls.add(src); preloaded.src = src; }
});
};
Controller.prototype.warmNext = function () {
if (!this.enabled || !this.auto || this.pending || this.ended || this.failed || this.stale || this.paused || this.navigating || this.restoring || this.destroyed || document.hidden || !this.nextUrl) return;
var connection = navigator.connection;
if (connection && connection.saveData) return;
var key = this.nextUrl.href;
if (this.buffer && this.buffer.key === key) return;
var self = this;
var buffer = { key: key, ready: false, result: null, error: null, promise: null };
this.buffer = buffer;
buffer.promise = this.fetchPage(new URL(key), this.meta.page + 1).then(function (result) {
buffer.ready = true; buffer.result = result;
if (!self.destroyed && !self.navigating && !self.paused) self.warmImages(result);
return { result: result };
}, function (error) {
buffer.error = error;
return { error: error };
});
};
Controller.prototype.revealAdded = function (card) {
if (!card || !card.isConnected) return;
var vp = this.viewport();
var top = this.headerBottom(vp);
if (this.bar && matchMedia('(max-width: 989px)').matches) top = Math.max(top, this.bar.getBoundingClientRect().bottom);
var delta = card.getBoundingClientRect().top - top - 12;
if (Math.abs(delta) < 1) return;
if (this.scrollRoot) this.scrollRoot.scrollBy({ top: delta, behavior: 'instant' });
else window.scrollBy({ top: delta, behavior: 'instant' });
};
Controller.prototype.captureAppendViewport = function (manual) {
if (this.restoring || document.hidden || !this.tools) return null;
var vp = this.viewport();
var r = this.tools.getBoundingClientRect();
var g = this.grid.getBoundingClientRect();
var readerMoved = this.inputSerial > 0 || this.scrollPosition() > this.initialScroll + 12;
var reachedEnd = r.top < vp.bottom - 40 && g.top < vp.bottom;
var reveal = manual;
var inList = g.bottom > this.headerBottom(vp) && g.top < vp.bottom;
if (!reveal && g.top >= vp.bottom) return null;
var scroller = this.scrollRoot || document.documentElement;
var anchorValue = scroller.style.getPropertyValue('overflow-anchor');
var anchorPriority = scroller.style.getPropertyPriority('overflow-anchor');
scroller.style.setProperty('overflow-anchor', 'none', 'important');
return { y: this.scrollPosition(), reveal: reveal, serial: this.inputSerial,
scroller: scroller, anchorValue: anchorValue, anchorPriority: anchorPriority };
};
Controller.prototype.settleAppendViewport = async function (saved, firstCard, manual) {
if (!saved) return;
var self = this;
this.correctingScroll = true;
function apply() {
if (self.destroyed || self.paused || self.navigating || !self.root.isConnected || document.hidden || self.inputSerial !== saved.serial) return;
if (!manual) return;
if (saved.reveal && firstCard) self.revealAdded(firstCard);
else if (self.scrollRoot) self.scrollRoot.scrollTo({ top: saved.y, behavior: 'instant' });
else window.scrollTo({ top: saved.y, behavior: 'instant' });
}
try {
apply();
await new Promise(function (resolve) {
var frame = 0;
var timer = setTimeout(function () { cancelAnimationFrame(frame); resolve(); }, 120);
frame = requestAnimationFrame(function () {
frame = requestAnimationFrame(function () { clearTimeout(timer); resolve(); });
});
});
apply();
if (manual && firstCard && self.inputSerial === saved.serial && !self.destroyed && !self.navigating && !document.hidden) {
var link = firstCard.querySelector('a[href]');
if (link) link.focus({ preventScroll: true });
}
} finally {
if (saved.anchorValue) saved.scroller.style.setProperty('overflow-anchor', saved.anchorValue, saved.anchorPriority);
else saved.scroller.style.removeProperty('overflow-anchor');
this.correctingScroll = false;
}
};
Controller.prototype.label = function (key) {
var displayTotal = this.ended ? this.cards.length : this.meta.total;
var values = { loaded: this.nf.format(this.cards.length), total: this.nf.format(displayTotal), remaining: this.nf.format(Math.max(0, this.meta.total - this.meta.offset - this.meta.pageSize)) };
return String(this.copy[key] || '').replace(/__(loaded|total|remaining)__/g, function (_, name) { return values[name]; });
};
Controller.prototype.renderState = function (message) {
if (!this.enabled) return;
this.root.dataset.ldFeedState = this.pending ? 'loading' : this.failed ? 'error' : this.ended ? 'complete' : 'idle';
if (this.grid) this.grid.setAttribute('aria-busy', this.pending ? 'true' : 'false');
var state = this.stale ? 'stale' : this.failed ? 'error' : this.ended ? 'complete' : 'more';
text(this.title, this.label(state + '_title'));
var msg = message || this.label(this.restoring ? 'restoring' : this.pending ? 'loading' : this.stale ? 'stale' : this.failed ? 'error' : this.ended ? (this.meta.total ? 'complete' : 'empty') : 'progress');
text(this.status, msg);
if (this.status) this.status.hidden = !msg;
text(this.hint, this.label(this.stale ? 'stale_hint' : this.failed ? 'error_hint' : this.ended ? 'complete_hint' : this.auto ? 'auto_hint' : 'manual_hint'));
if (this.skeleton) this.skeleton.hidden = !this.pending || this.restoring;
if (this.tools) this.tools.setAttribute('aria-busy', this.pending ? 'true' : 'false');
if (this.loadButton) {
this.loadButton.hidden = this.ended || this.stale;
this.loadButton.disabled = this.pending;
text(this.loadButton, this.label(this.pending ? 'loading_button' : this.failed ? 'retry_button' : 'load_button'));
}
if (this.autoButton) {
this.autoButton.hidden = this.ended || this.stale;
this.autoButton.setAttribute('aria-pressed', this.auto ? 'true' : 'false');
text(this.autoButton, this.label(this.auto ? 'pause_button' : 'auto_button'));
}
if (this.fallback) {
this.fallback.hidden = !this.failed;
var href = this.stale ? new URL(this.startUrl.href) : this.nextUrl;
if (this.stale && href) href.searchParams.delete(this.meta.pageParam);
this.fallback.href = href ? href.href : this.startUrl.href;
text(this.fallback, this.label(this.stale ? 'refresh_button' : 'next_button'));
}
this.updateMeter();
};
Controller.prototype.fetchHTML = async function (url) {
var self = this;
var controller = new AbortController(); this.abort = controller;
var timer = setTimeout(function () { controller.abort(); }, this.timeoutMs);
try {
var response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: controller.signal });
if (!response.ok) throw new Error('HTTP ' + response.status);
var html = await response.text();
if (self.paused || self.navigating || self.destroyed) throw new Error('Przerwano ładowanie.');
return html;
} finally {
clearTimeout(timer);
if (this.abort === controller) this.abort = null;
}
};
Controller.prototype.readResponse = function (html, expectedPage) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var root = all(doc, ROOT).find(function (el) { return el.dataset.ldSection === this.id; }, this);
var m = metaFrom(root);
if (m.section !== this.id || signature(m) !== this.sig) throw new Error('Odpowiedź nie pasuje do wybranej kolekcji lub filtrów.');
if (m.page !== expectedPage || this.visited.has(m.page)) throw new Error('Sklep zwrócił niewłaściwą stronę produktów.');
if (m.total !== this.meta.total || m.pageSize !== this.meta.pageSize) {
var changed = new Error('Liczba produktów zmieniła się podczas przeglądania.'); changed.stale = true; throw changed;
}
var end = this.meta.offset + this.meta.pageSize;
if (m.offset !== end) throw new Error('Niespójny początek kolejnej strony.');
var grid = root.querySelector('[data-ld-product-grid]');
if (!grid) throw new Error('Brak produktów w odpowiedzi.');
var cards = directCards(grid);
this.validateCards(cards, m, true);
var next = m.next ? this.resolvePage(m.next, m.page + 1) : null;
if (!next && Math.min(m.offset + m.pageSize, m.total) !== m.total) throw new Error('Odpowiedź kończy listę przed ostatnim produktem.');
return { doc: doc, root: root, grid: grid, meta: m, next: next, cards: cards };
};
Controller.prototype.uniqueIDs = function (element, reserved, suffix) {
var map = new Map();
var nodes = all(element, '[id]');
if (element.id) nodes.unshift(element);
nodes.forEach(function (node, index) {
var old = node.id;
var next = old;
if (reserved.has(next)) {
next = old + '-' + suffix + '-' + index;
while (reserved.has(next)) next += '-x';
node.id = next; map.set(old, next);
}
reserved.add(next);
});
all(element, '[for], [form], [aria-controls], [aria-labelledby], [aria-describedby], [href^="#"]').forEach(function (node) {
['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attr) {
if (!node.hasAttribute(attr)) return;
node.setAttribute(attr, node.getAttribute(attr).split(/\s+/).map(function (id) { return map.get(id) || id; }).join(' '));
});
var href = node.getAttribute('href');
if (href && map.has(href.slice(1))) node.setAttribute('href', '#' + map.get(href.slice(1)));
});
};
Controller.prototype.load = async function (manual) {
if (!this.enabled || this.pending || this.ended || this.stale || this.paused || this.navigating || !this.nextUrl || this.destroyed) return false;
if (this.failed && !manual) return false;
this.autoArmed = false;
var restoringRequest = this.restoring;
var expectedPage = this.meta.page + 1;
var pageURL = new URL(this.nextUrl.href);
this.pending = true; this.failed = false;
delete this.root.dataset.ldFeedError;
this.renderState();
var result = null;
try {
var buffer = this.buffer && this.buffer.key === pageURL.href ? this.buffer : null;
if (buffer) {
var buffered = await buffer.promise;
if (this.buffer === buffer) this.buffer = null;
if (buffered.error && buffered.error.stale) throw buffered.error;
result = buffered.result || await this.fetchPage(pageURL, expectedPage);
} else result = await this.fetchPage(pageURL, expectedPage);
if (this.paused || this.navigating || this.destroyed || !this.root.isConnected) return false;
var reserved = new Set(all(document, '[id]').map(function (el) { return el.id; }));
var fragment = document.createDocumentFragment();
var added = [];
var self = this;
var adIds = new Set((this.root.dataset.ldAdIds || '').split(',').filter(Boolean));
Array.from(result.grid.children).forEach(function (node, index) {
if (!node.hasAttribute('data-ld-product-id') && !node.hasAttribute('data-ld-feed-promo')) return;
if (adIds.has(node.dataset.ldProductId)) { node.setAttribute('data-ld-ad-duplicate', ''); node.hidden = true; }
self.uniqueIDs(node, reserved, 'ld-p' + expectedPage + '-' + index);
self.prepare(node, true);
var adopted = document.adoptNode(node);
fragment.appendChild(adopted); added.push(adopted);
});
var savedViewport = restoringRequest ? null : this.captureAppendViewport(manual);
this.grid.appendChild(fragment);
var firstAdded = added.find(function (el) { return el.hasAttribute('data-ld-product-id') && !el.hasAttribute('data-ld-ad-duplicate'); });
await this.settleAppendViewport(savedViewport, firstAdded, manual);
this.cards = directCards(this.grid);
this.ids = new Set(this.cards.map(function (c) { return c.dataset.ldProductId; }));
this.meta = result.meta; this.nextUrl = result.next;
this.visited.add(result.meta.page);
this.ended = !this.nextUrl;
if (this.ended && this.observer) this.observer.disconnect();
this.root.dispatchEvent(new CustomEvent('ld:products:added', { bubbles: true, detail: { sectionId: this.id, page: this.meta.page, productsAdded: result.cards.length, productsLoaded: this.cards.length, elements: added } }));
return true;
} catch (error) {
if (!this.paused && !this.navigating && !this.destroyed) {
this.failed = true; this.stale = !!error.stale;
this.root.dataset.ldFeedError = String(error.message || error);
console.warn('[ŁD lista produktów]', error.message);
}
return false;
} finally {
this.pending = false;
if (!this.destroyed && this.root.isConnected) {
this.renderState();
this.resetLoadGate();
this.warmNext();
this.requestFrame();
}
}
};
Controller.prototype.savePosition = function () {
var cards = visibleCards(this.cards);
if (this.destroyed || this.navigating || !cards.length || this.restoring) return;
var vp = this.viewport();
var top = this.bar && matchMedia('(max-width: 989px)').matches ? Math.max(vp.top, this.bar.getBoundingClientRect().bottom) : this.headerBottom(vp);
var anchor = cards.find(function (card) { return card.getBoundingClientRect().bottom > top + 15; }) || cards[cards.length - 1];
storageSet(this.resumeKey, JSON.stringify({ time: Date.now(), sig: this.sig, total: this.meta.total, initialPage: this.initialPage, id: anchor.dataset.ldProductId, index: number(anchor.dataset.ldProductIndex, 0), top: anchor.getBoundingClientRect().top }));
};
Controller.prototype.tryRestore = async function () {
if (document.documentElement.classList.contains('ld-ad-pending')) {
if (this.waitingForAd) return;
this.waitingForAd = true;
var self = this;
var timer;
var ready = function () { requestAnimationFrame(resume); };
var resume = function () {
if (!self.waitingForAd || self.destroyed || document.documentElement.classList.contains('ld-ad-pending')) return;
clearTimeout(timer);
self.root.removeEventListener('ld:ad:ready', ready);
document.removeEventListener('ld:ad:release', resume);
self.waitingForAd = false;
self.tryRestore(); self.requestFrame();
};
listen(this.root, 'ld:ad:ready', ready, false, this.off);
listen(document, 'ld:ad:release', resume, false, this.off);
timer = setTimeout(resume, 6500);
this.off.push(function () { clearTimeout(timer); });
return;
}
var entry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
if (!this.enabled || !entry || entry.type !== 'back_forward') return;
var saved;
try { saved = JSON.parse(storageGet(this.resumeKey) || 'null'); } catch (_) { return; }
if (!saved || saved.sig !== this.sig || saved.total !== this.meta.total || saved.initialPage !== this.initialPage || Date.now() - saved.time > 15 * 60 * 1000) return;
this.restoreTarget = saved; this.restoring = true; this.renderState();
var safety = this.meta.pages + 1;
while (!this.destroyed && this.restoring && !this.ids.has(saved.id) && !this.ended && safety-- > 0) {
if (!(await this.load(true))) break;
}
if (this.restoring && !this.destroyed) {
var cards = visibleCards(this.cards);
var anchor = cards.find(function (card) { return card.dataset.ldProductId === saved.id; }) || cards.find(function (card) { return number(card.dataset.ldProductIndex, 0) >= saved.index; });
if (anchor) {
var delta = anchor.getBoundingClientRect().top - saved.top;
if (this.scrollRoot) this.scrollRoot.scrollBy({ top: delta, behavior: 'instant' });
else window.scrollBy({ top: delta, behavior: 'instant' });
}
this.restoring = false; this.restoreTarget = null; this.renderState(); this.warmNext(); this.requestFrame();
}
};
Controller.prototype.destroy = function () {
this.destroyed = true; this.buffer = null;
if (this.abort) this.abort.abort();
if (this.observer) this.observer.disconnect();
if (this.resizeObserver) this.resizeObserver.disconnect();
if (this.frame) cancelAnimationFrame(this.frame);
this.off.forEach(function (off) { off(); }); this.off = [];
};
function boot(scope) {
var roots = all(scope, ROOT);
if (scope.matches && scope.matches(ROOT)) roots.unshift(scope);
roots.forEach(function (root) {
var id = root.dataset.ldSection;
var old = instances.get(id);
if (old && old.root === root && !old.destroyed) return;
if (old) old.destroy();
try { instances.set(id, new Controller(root)); }
catch (error) {
console.warn('[ŁD uruchomienie listy]', error.message);
root.dataset.ldFeedState = 'init-error';
root.dataset.ldFeedError = String(error.message || error);
var pager = root.querySelector('[data-ld-pagination]'); if (pager) pager.hidden = false;
}
});
}
function destroyAll() {
instances.forEach(function (item) { item.destroy(); }); instances.clear();
globalOff.forEach(function (off) { off(); }); globalOff = [];
}
window.LDCollectionFeed = { version: VERSION, boot: boot, destroy: destroyAll,
prepare: function (scope) {
var root = scope && scope.closest && scope.closest(ROOT);
var c = root && instances.get(root.dataset.ldSection);
if (c && c.root === root && !c.destroyed) { c.prepare(scope, true); c.requestFrame(); }
},
diagnostics: function () {
return all(document, ROOT).map(function (root) {
var c = instances.get(root.dataset.ldSection);
return { section: root.dataset.ldSection, build: root.dataset.ldBuild,
controller: root.dataset.ldController || null,
state: root.dataset.ldFeedState || 'not-started',
error: root.dataset.ldFeedError || null,
page: c ? c.meta.page : null, loaded: c ? c.cards.length : null,
auto: c ? c.auto : null, armed: c ? c.autoArmed : null,
pending: c ? c.pending : null, buffered: c ? !!(c.buffer && c.buffer.ready) : null, prefetchDistance: c ? Math.round(c.loadDistance()) : null };
});
}
};
listen(document, 'shopify:section:load', function (e) { boot(e.target); }, false, globalOff);
listen(document, 'shopify:section:unload', function (e) {
instances.forEach(function (item, id) {
if (e.target.contains(item.root)) { item.destroy(); instances.delete(id); }
});
}, false, globalOff);
if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', function () { boot(document); }, { once: true }, globalOff);
else boot(document);
})();
